import ExportAnnotation from '../src/annotations/ExportAnnotation'

export default ExportAnnotation
